<template>
    <b-modal id="modal-info-quimica"
             title="Conceptos fundamentales"
             size="lg"
             centered
             v-model="show"
             hide-footer
    >
        <template #modal-header>
            <h5 class="modal-title">
                <i class="fa fa-info mr-2"></i>
                Conceptos fundamentales
            </h5>
            <b-button size="sm"
                      variant="light"
                      @click="show = false"
                      class="text-dark"
            >
                <i class="fa fa-close"></i>
            </b-button>
        </template>

        <div class="modal-body">
            <p>La diferencia entre <strong>sustancia, producto y reacción</strong> radica en su definición
                dentro
                de la química:</p>

            <div class="concept-card sustancia">
                <h5 class="mb-0 ml-1 text-success">
                    Sustancia
                </h5>
                <p class="mt-2">Es cualquier tipo de materia que tiene una composición definida y propiedades
                    específicas. Puede
                    ser un <strong>elemento</strong> (como el oxígeno, O<span class="sub">2</span>) o un
                    <strong>compuesto</strong> (como el agua, H<span class="sub">2</span>O).</p>
                <p><strong>Ejemplo:</strong> el ácido sulfúrico (H<span class="sub">2</span>SO<span class="sub">4</span>)
                    es una
                    sustancia química.</p>
            </div>

            <div class="concept-card producto">
                <h5 class="mb-0 ml-1 text-primary">
                    Producto
                </h5>
                <p class="mt-2">Son las sustancias que se forman después de que las mismas han interactuado.</p>
                <p><strong>Ejemplo:</strong> en la combustión del metano, los productos son dióxido de carbono
                    (CO<span class="sub">2</span>) y agua (H<span class="sub">2</span>O).</p>
            </div>

            <div class="concept-card reaccion">
                <h5 class="mb-0 ml-1 text-danger">
                    Reacción
                </h5>
                <p class="mt-2">Es el <strong>proceso químico</strong> mediante el cual unas sustancias reaccionan entre
                    sí para
                    obtener un producto.</p>
                <p>
                    <strong>Ejemplo:</strong>
                    <div class="text-center my-3">
                        <span class="molecule">CH<span class="sub">4</span></span> +
                        <span class="molecule">2O<span class="sub">2</span></span> →
                        <span class="molecule">CO<span class="sub">2</span></span> +
                        <span class="molecule">2H<span class="sub">2</span>O</span>
                    </div>
                    Aquí, el metano (<strong>CH<span class="sub">4</span></strong>) y el oxígeno
                    (<strong>O<span class="sub">2</span></strong>) son los reactivos, mientras que el dióxido de carbono
                    (<strong>CO<span class="sub">2</span></strong>) y el agua
                    (<strong>H<span class="sub">2</span>O</strong>)
                    son los productos.
                </p>
            </div>

            <div class="resumen">
                <h5>En resumen:</h5>
                <ul>
                    <li><strong>Sustancia: </strong> Materia con composición definida.</li>
                    <li><strong>Producto: </strong> Resultado de la combinación de sustancias.</li>
                    <li><strong>Reacción: </strong> Cambio químico donde unas sustancias interactúan entre sí obteniendo
                        un
                        resultado.
                    </li>
                </ul>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'modal',
    data() {
        return {
            show: false
        };
    },
    methods: {
        openModal() {
            this.show = true;
        }
    }
};
</script>

<style>

.concept-card {
    border-left: 4px solid;
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f8f9fa;
    border-radius: 5px;
}

.sustancia {
    border-left-color: #42b983;
}

.producto {
    border-left-color: #3490dc;
}

.reaccion {
    border-left-color: #e3342f;
}

.molecule {
    display: inline-block;
}

.sub {
    font-size: 75%;
    vertical-align: sub;
}

.resumen {
    background-color: #f1f8ff;
    border-radius: 8px;
    padding: 15px;
    margin-top: 20px;
}

.resumen ul {
    list-style-type: none;
    padding-left: 0;
}

.resumen li {
    padding: 5px 0;
    display: flex;
    align-items: center;
}

.resumen li:before {
    content: "•";
    margin-right: 10px;
    color: #42b983;
    font-weight: bold;
}
</style>
